import React from 'react';

import { injectIntl } from 'react-intl';
import { useOwner } from '../context/context.js';

import OwnerMenu from '../ui_items/OwnerMenu.js';

const IntegrationsMainMenu = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false || parseInt(promotion.promo_type) < 1) return null;
	const is_wl = (parseInt(promotion.promo_type) == 2) ? true : false;
	const quiz_monitor = props?.quiz_monitor ?? false;
	const selected = props?.selected ?? false;

	let _s = {};

	/*_s.general = {
		title:"General",
		items:[{
			url:`/promotions/profile/${promotion.id}`,
			icon:'knk-home',
			selected:(selected == 'profile') ? true : false,
			children:"Home",
		}],
	}*/

	_s.integrations = {
		title:"Integrations",
		items:[{
			enabled:(is_wl) ? true : false,
			url:`/integrations/facebook/${promotion.id}`,
			icon:'ep-facebook',
			selected:(selected == 'facebook') ? true : false,
			children:"Facebook",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/google/${promotion.id}`,
			icon:'ep-google',
			selected:(selected == 'google') ? true : false,
			children:"Google",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/linkedin/${promotion.id}`,
			icon:'ep-linked-in',
			selected:(selected == 'linkedin') ? true : false,
			children:"Linkedin",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/twitch/${promotion.id}`,
			icon:'ep-twitch',
			selected:(selected == 'twitch') ? true : false,
			children:"Twitch",
		}, {
			enabled:((window?.hide_twitter ?? false) == false) ? true : false,
			url:`/integrations/twitter/${promotion.id}`,
			icon:'ep-twitter',
			selected:(selected == 'twitter') ? true : false,
			children:"Twitter",
		}, {
			enabled:true,
			url:`/integrations/instagram/${promotion.id}`,
			icon:'ep-instagram',
			selected:(selected == 'instagram') ? true : false,
			children:"Instagram",
		}, {
			enabled:true,
			url:`/integrations/dropbox/${promotion.id}`,
			icon:'ep-dropbox',
			selected:(selected == 'dropbox') ? true : false,
			children:"Dropbox",
		}, {
			enabled:true,
			url:`/integrations/google_analytics/${promotion.id}`,
			icon:'ep-google-analytics',
			selected:(selected == 'google_analytics_ua') ? true : false,
			children:"Google Analytics",
		}, {
			enabled:true,
			url:`/integrations/mailchimp/${promotion.id}`,
			icon:'ep-mailchimp',
			selected:(selected == 'mailchimp') ? true : false,
			children:"Mailchimp",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/selligent/${promotion.id}`,
			icon:'ep-selligent',
			selected:(selected == 'selligent') ? true : false,
			children:"Selligent",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/hubspot/${promotion.id}`,
			icon:'ep-hubspot',
			selected:(selected == 'hubspot') ? true : false,
			children:"Hubspot",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/campaign_monitor/${promotion.id}`,
			icon:'ep-campaign-monitor',
			selected:(selected == 'campaign_monitor') ? true : false,
			children:"Campaign Monitor",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/active_campaign/${promotion.id}`,
			icon:'ep-active-campaign',
			selected:(selected == 'active_campaign') ? true : false,
			children:"Active Campaign",
		}, {
			enabled:false,
			url:`/integrations/salesforcemc/${promotion.id}`,
			icon:'ep-salesforce',
			selected:(selected == 'salesforcemc') ? true : false,
			children:"Salesforce Marketing Cloud",
		}, {
			enabled:false,
			url:`/integrations/mailgun/${promotion.id}`,
			icon:'ep-mailgun',
			selected:(selected == 'mailgun') ? true : false,
			children:"Mailgun",
		}, {
			enabled:true,
			url:`/integrations/sendinblue/${promotion.id}`,
			icon:'ep-brevo',
			selected:(selected == 'sendinblue') ? true : false,
			children:"Brevo (Sendinblue)",
		}, {
			enabled:true,
			url:`/integrations/getresponse/${promotion.id}`,
			icon:'ep-get-response',
			selected:(selected == 'getresponse') ? true : false,
			children:"GetResponse",
		}, {
			enabled:true,
			url:`/integrations/mailjet/${promotion.id}`,
			icon:'ep-mailjet',
			selected:(selected == 'mailjet') ? true : false,
			children:"Mailjet",
		}, {
			enabled:true,
			url:`/integrations/zendesk_sell/${promotion.id}`,
			icon:'ep-zendesk-sell',
			selected:(selected == 'zendesk_sell') ? true : false,
			children:"Zendesk Sell",
		}, {
			enabled:true,
			url:`/integrations/constantcontact/${promotion.id}`,
			icon:'ep-constant-contact',
			selected:(selected == 'constantcontact') ? true : false,
			children:"ConstantContact",
		}, {
			enabled:true,
			url:`/integrations/freshsales/${promotion.id}`,
			icon:'ep-freshsales',
			selected:(selected == 'freshsales') ? true : false,
			children:"Freshsales",
		}, {
			enabled:false,
			url:`/integrations/zohocrm/${promotion.id}`,
			icon:'ep-zoho-crm',
			selected:(selected == 'zohocrm') ? true : false,
			children:"ZohoCRM",
		}, {
			enabled:false,
			url:`/integrations/intercom/${promotion.id}`,
			icon:'ep-intercom',
			selected:(selected == 'intercom') ? true : false,
			children:"Intercom",
		}, {
			enabled:false,
			url:`/integrations/aweber/${promotion.id}`,
			icon:'ep-aweber',
			selected:(selected == 'aweber') ? true : false,
			children:"AWeber",
		}, {
			enabled:true,
			url:`/integrations/wordpress/${promotion.id}`,
			icon:'ep-wordpress',
			selected:(selected == 'wordpress') ? true : false,
			children:"Wordpress",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/api/${promotion.id}`,
			icon:'knk-ip',
			selected:(selected == 'api') ? true : false,
			children:"Entrants API",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/webhook/${promotion.id}`,
			icon:'ep-webhooks',
			selected:(selected == 'webhook') ? true : false,
			children:"WebHooks",
		}, {
			enabled:(is_wl) ? true : false,
			url:`/integrations/xeerpa/${promotion.id}`,
			icon:'ep-xeerpa',
			selected:(selected == 'xeerpa') ? true : false,
			children:"Xeerpa",
		}, {
			enabled:(quiz_monitor) ? true : false,
			url:`/integrations/quiz/${promotion.id}`,
			icon:'knk-quiz',
			selected:(selected == 'quiz') ? true : false,
			children:"Live Predictions Display",
		}],
	}

	return (
		<OwnerMenu
			sections={Object.values(_s)}
			scrollable={true}
		/>
	)
}

export default injectIntl(IntegrationsMainMenu);